import { BrowserRouter as Router } from "react-router-dom";
import MainComponent from "./components/MainLayout";
import AuthProvider from "./providers/AuthProvider";
import MessageProvider from "./providers/message-provider";
import ChatProvider from "./providers/chat-provider";

function App() {
  return (
    <Router>
      <AuthProvider>
        <MessageProvider />
        <ChatProvider>
          <MainComponent />
        </ChatProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
